// test1984
(1984 && 0);
